module.exports = __webpack_public_path__ + "img/index9.0f2a463d.jpg";